// extracted by mini-css-extract-plugin
export default {"trade-panel__change":"rZ_PVyDtiO05ZSaPMUt3"};